import alertsMetadataReducer from '../slices/alertsMetadataSlice';
import alertsReducer from '../slices/alertsSlice';
import appSummaryReducer from '../slices/appSummarySlice';
import configReducer from '../slices/configSlice';
import dictionaryReducer from '../slices/dictionarySlice';
import employeeReducer from '../slices/employeeSlice';
import employerReducer from '../slices/employerSlice';
import loanDetailsReducer from '../slices/loanDetailsSlice';
import notificationReducer from '../slices/notificationSlice';
import payrollReducer from '../slices/payrollSlice';
import primaryBankReducer from '../slices/primaryBankSlice';
import productsReducer from '../slices/productsSlice';
import queueReducer from '../slices/queueSlice';
import userReducer from '../slices/userSlice';

import { Action, combineReducers, configureStore, ThunkAction } from '@reduxjs/toolkit';

const rootReducer = combineReducers({
    user: userReducer,
    employee: employeeReducer,
    queue: queueReducer,
    employer: employerReducer,
    config: configReducer,
    dictionary: dictionaryReducer,
    loanDetails: loanDetailsReducer,
    appSummary: appSummaryReducer,
    primaryBank: primaryBankReducer,
    payroll: payrollReducer,
    alerts: alertsReducer,
    alertsMetadata: alertsMetadataReducer,
    notifications: notificationReducer,
    products: productsReducer
});

export function setupStore(preloadedState?: Partial<RootState>) {
    return configureStore({
        reducer: rootReducer,
        preloadedState
    })
}

export const store = setupStore();

export type RootState = ReturnType<typeof rootReducer>
export type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = AppStore['dispatch']

export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
